import { createRoot } from "react-dom/client";
import {
  applyAccentColor,
  applyTheme,
  getStoredAccentId,
  getStoredTheme,
} from "./hooks/use-theme";
import App from "./App";
import "./index.css";

applyTheme(getStoredTheme());
applyAccentColor(getStoredAccentId());

createRoot(document.getElementById("root")!).render(<App />);
